/**
 * Манифест ассетов загрузочного экрана.
 *
 * Каждый показ выбирает случайную картинку + случайный звук.
 * Картинки в WebP (sqrt 10× компрессия по сравнению с PNG).
 * Звуки — 5 секунд каждый, ElevenLabs sound-generation.
 *
 * Vite импортирует ассеты с хешем в имя при билде, поэтому
 * импортируем явно — отдаёт готовый URL.
 */
import loader15 from '@/assets/loader/loader-15.webp';
import loader28 from '@/assets/loader/loader-28.webp';
import loader34 from '@/assets/loader/loader-34.webp';
import loader35 from '@/assets/loader/loader-35.webp';
import loader46 from '@/assets/loader/loader-46.webp';
import loader48 from '@/assets/loader/loader-48.webp';
import loader52 from '@/assets/loader/loader-52.webp';

// Утверждённые админом звуки (v1 + v2). #09 удалён из ротации.
import sound04 from '@/assets/loader/sounds/sound_04.mp3';
import sound07 from '@/assets/loader/sounds/sound_07.mp3';
import sound13 from '@/assets/loader/sounds/sound_13.mp3';
import sound15 from '@/assets/loader/sounds/sound_15.mp3';
import sound16 from '@/assets/loader/sounds/sound_16.mp3';
import sound18 from '@/assets/loader/sounds/sound_18.mp3';
import sound20 from '@/assets/loader/sounds/sound_20.mp3';

export const LOADER_IMAGES = [
  loader15,
  loader28,
  loader34,
  loader35,
  loader46,
  loader48,
  loader52,
];

export const LOADER_SOUNDS = [
  sound04,
  sound07,
  sound13,
  sound15,
  sound16,
  sound18,
  sound20,
];

export function pickRandomImage(): string {
  return LOADER_IMAGES[Math.floor(Math.random() * LOADER_IMAGES.length)];
}

export function pickRandomSound(): string {
  return LOADER_SOUNDS[Math.floor(Math.random() * LOADER_SOUNDS.length)];
}

/** Случайная длительность лоадера [min, max] в мс. */
export function pickDuration(min = 5000, max = 8000): number {
  return Math.floor(min + Math.random() * (max - min));
}
